//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import gStartUp from '@/common/components/g-start-up/'
import { mapState } from 'vuex';
import { filter } from '@/common/index';
export default {
  name: 'App',
  // components: { gStartUp },
  provide() {
    return {
      parentRoot: this,
    }
  },
  filters: {
        getTimeMS(time) {
            return filter.getTimeMS(time)
        }
    },
  computed: {
      ...mapState({
          isToLogin:state => state.isToLogin,
          UUID: state => state.UUID,
          pushList: state => state.pushList,
      }),
    viewHeight() { // 可是区域的高度
      return (document.documentElement.clientHeight || document.body.clientHeight) + 'px'
    }
  },
  watch: {
    isToLogin(newVal, oldVal) {
        if (newVal > 0) {
            this.isShowNotic = true
        }
    }
  },
  data() {
    return {
        isShowNotic: false,
      isRouterAlive: true ,// 路由刷新
      // startImg: require('./assets/image/common/start-up.jpg')
    }
  },
  created() {
    document.title='Online Casino | Online Betting | Gamble Online India | Ek.bet';
    actionLogEvent("af_customer", { af_eventName: `af_first_enter` });
  },
  methods: {
    reload() { // 刷新页面, 比如页面切换多语言数据重置
       this.isRouterAlive = false
       this.$nextTick(function(){
          this.isRouterAlive = true
       })
    },
    jumpMsg() {
        localStorage.setItem('msgTabIndex', 1);
        this.isShowNotic = false;
        // this.$router.push({path: '/My/StationLetter'})
        this.$router.push({path: '/inbox'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build821/App.vue